import {
  WORKSPACE_FRAME_PADDING,
  WORKSPACE_PADDING,
  WORKSPACE_PADDING_MOBILE,
  getWorkspaceFrameStyles,
} from '@components/v2/constants';
import { makeStyles } from 'tss-react/mui';
import { SidebarState } from './appTemplate.types';

interface StyleParams {
  sidebarState: SidebarState;
  isMobile: boolean;
}

export const useAppTemplateStyles = makeStyles<StyleParams>()(
  (theme, { sidebarState, isMobile }) => {
    const framePadding = theme.spacing(WORKSPACE_FRAME_PADDING);
    const SIDEBAR_FRAME_GAP = sidebarState === 'collapsed' ? 0 : theme.spacing(0.25);
    const leftInset = isMobile || sidebarState === 'hidden' ? framePadding : SIDEBAR_FRAME_GAP;

    return {
      root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        background: theme.palette.background.default,
        overflow: 'hidden',
      },
      middle: {
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
      },
      workspaceArea: {
        display: 'flex',
        flex: 1,
        minWidth: 0,
        position: 'relative',
        overflow: 'hidden',
      },
      contentArea: {
        flexShrink: 1,
        flexBasis: 0,
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        display: 'flex',
        position: 'relative',
        zIndex: 0,
        flexGrow: 1,
        paddingRight: framePadding,
        paddingLeft: leftInset,
        transition: theme.transitions.create('padding', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
        '@media (prefers-reduced-motion: reduce)': {
          transition: 'none',
        },
        [theme.breakpoints.down('sm')]: {
          paddingRight: 0,
          paddingLeft: 0,
        },
      },
      contentFrame: {
        flex: 1,
        position: 'relative',
        ...getWorkspaceFrameStyles(theme),
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingInline: theme.spacing(WORKSPACE_PADDING),
        [theme.breakpoints.down('sm')]: {
          marginTop: 0,
          paddingInline: theme.spacing(WORKSPACE_PADDING_MOBILE),
        },
      },
      sidebarWrapper: {
        transition: 'filter 60ms ease, opacity 60ms ease',
        willChange: 'filter, opacity',
      },
      sidebarBlurring: {
        filter: 'blur(2px)',
        opacity: 0.85,
      },
    };
  },
);
